// Zuständige einer persönlichen Aufgabe / eines Schritts aus einem API-Payload
// lesen (#854).
//
// Seit Migration 0089 ist `assignee_ids` die Wahrheit (mehrere Personen, erste =
// primär). `assignee_id` bleibt im Payload als primäre Kurzform — und ist der
// einzige Wert, den ein Payload eines ÄLTEREN Servers liefert. Diese Funktion
// kapselt genau diesen Vorrang, damit die Reihenfolge nicht an jeder Aufrufstelle
// neu entschieden (und irgendwo falsch) wird.

export interface WithAssignees {
  assignee_ids?: number[];
  assignee_id?: number | null;
}

/** Alle Zuständigen, primäre Person zuerst. Leeres Array = niemand zugewiesen. */
export function personalAssigneeIds(t: WithAssignees | null | undefined): number[] {
  if (!t) return [];
  if (t.assignee_ids) return t.assignee_ids;
  return t.assignee_id != null ? [t.assignee_id] : [];
}
